var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProductDetails',{attrs:{"activityProducts":_vm.activityProductsWithProductId,"currentActivityProductId":_vm.currentActivityProductId,"products":_vm.products,"storagePlaces":_vm.storagePlaces},on:{"update:currentActivityProductId":_vm.updateCurrentActivityProductId}})
}
var staticRenderFns = []

export { render, staticRenderFns }